import MenuProvider from "../providers/menu";

import LoadingSpinner from "../components/loading-spinner";

import useApiRequest from "../hooks/use-api-request";

export const ProvideMenuData = ({ children }) => {
  const { data, loading } = useApiRequest("sidebars/1");
  if (loading) {
    return <LoadingSpinner />;
  }
  <MenuProvider data={data}>{children}</MenuProvider>;
};
